import { StaticPane } from '../Appearance/StaticPane/StaticPane';
import { MockStaticPane } from '../Appearance/StaticPane/MockStaticPane';
var StaticPaneFactory = /** @class */ (function () {
    function StaticPaneFactory() {
    }
    StaticPaneFactory.getStaticPane = function () {
        if (window.TL && window.TL.modules) {
            return new StaticPane();
        }
        return new MockStaticPane();
    };
    return StaticPaneFactory;
}());
export { StaticPaneFactory };
